(function () {
  ////// descriptiuon produit

  document.addEventListener("DOMContentLoaded", function () {
    const description = document.querySelector(".product__description");

    // Créer le bouton "Lire plus"
    const readMoreBtn = document.createElement("button");
    readMoreBtn.className = "read-more-btn";
    readMoreBtn.textContent = "Lire la suite";

    // Ajouter le bouton au conteneur du texte
    description?.insertAdjacentElement("afterend", readMoreBtn);
    // Ajouter un écouteur d'événement au bouton
    readMoreBtn.addEventListener("click", function () {
      description.classList.toggle("expanded");
      if (description.classList.contains("expanded")) {
        readMoreBtn.textContent = "Lire moins";
      } else {
        readMoreBtn.textContent = "Lire la suite";
      }
    });
  });
  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth < 780) {
      const description = document.querySelector(".collection__description");
      if (description) {
        // Créer le bouton "Lire plus"
        const readMoreBtn = document.createElement("button");
        readMoreBtn.className = "read-more-btn";
        readMoreBtn.textContent = "Lire la suite";

        // Ajouter le bouton au conteneur du texte
        description.insertAdjacentElement("afterend", readMoreBtn);
        // Ajouter un écouteur d'événement au bouton
        readMoreBtn.addEventListener("click", function () {
          description.classList.toggle("opened");
          if (description.classList.contains("opened")) {
            readMoreBtn.textContent = "Lire moins";
          } else {
            readMoreBtn.textContent = "Lire la suite";
          }
        });
      }
    }
  });
  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth < 780) {
      document
        .querySelectorAll(
          ".mobile-menu__item--level-1.mobile-menu__item--has-items, .mobile-menu__item--level-2.mobile-menu__item--has-items"
        )
        .forEach((item) => {
          const link = item.querySelector(
            "a.mobile-navlink--level-1, a.mobile-navlink--level-2"
          );
          const trigger = item.querySelector("button.mobile-nav__trigger");

          if (link && trigger) {
            link.addEventListener("click", (event) => {
              event.preventDefault();
              trigger.click();
            });
          }
        });
    }
  });
})();
